import React from 'react';
import { AutoComplete, Button, Input, InputNumber, Select, Switch, Icon, Cascader } from 'antd';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
import AdvancedExport from './AdvancedExport';
import SearchRetrieve from '../common/SearchRetrieve.new.js';
import SearchMulSelect from '../common/SearchMulSelect';
import './css/list.less';
import fp from '../../utils/fp';
import SearchMulRetrieve from '../common/SearchMulRetrieve.js';

const InputGroup = Input.Group;
const Option = Select.Option;
const StartStateList = [
    { label: '中心都未启动', value: 'siteNoStart' },
    { label: '首家中心启动', value: 'firstSiteStart' },
    { label: '中心全部启动', value: 'siteAllStart' },
];
const InvestigationNatureList = [
    { label: '启动前', value: '启动前' },
    { label: '启动后', value: '启动后' },
    { label: '启动前+启动后', value: '启动前+启动后' },
];

class Filter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            diseaseList: [],
            byStageList: [],
            diseaseClassList: [],
            expand: false,
            invProceedOptions:[],
            investigationProceeds:null,
            advancedExportShow: false,
            stageList: [],
        };
    }

    componentDidMount() {
        this.loadDiseaseClassList();
        this.loadInvestigationByStageList();
        const { searchParams } = this.props;
        // if (searchParams.statusId) {
            this.getStageList(searchParams.statusId);
        // }
    }

    search = () => {
        this.props.search();
    }

    reset = () => {
        this.setState({investigationProceeds:[]})
        this.props.reset();
    }


    loadDiseaseClassList = () => {
        const { searchParams: { investigationAreaId } } = this.props;
        if (investigationAreaId) {
            const options = {
                method: 'POST',
                url: API_URL.common.queryDiseaseClassByAreaId,
                data: { investigationAreaId },
                dataType: 'json',
                doneResult: res => {
                    this.setState({ diseaseClassList: res.data });
                }
            }
            $.sendRequest(options);
        } else {
            this.setState({ diseaseClassList: [] });
        }
    }

    loadDiseaseList = (value) => {
        const { searchParams } = this.props;
        const { investigationAreaId, diseaseClassId } = searchParams;
        if (investigationAreaId) {
            const options = {
                method: 'POST',
                url: diseaseClassId ? API_URL.common.queryDiseaseByClassId : API_URL.common.queryAllDisease,
                data: {
                    keyword: value,
                    diseaseClassId,
                    investigationAreaId,
                },
                dataType: 'json',
                doneResult: res => {
                    this.setState({ diseaseList: res.data });
                }
            };
            $.sendRequest(options);
        } else {
            this.setState({ diseaseList: [] });
        }
    }

    loadInvestigationByStageList = () => {
        const { searchParams: { investigationMedicineType = [] } } = this.props;
        if (investigationMedicineType[0]) {
            const options = {
                method: 'POST',
                url: API_URL.common.queryInvestigationByStageByMedicine,
                data: { investigationMedicineType: investigationMedicineType[0] },
                dataType: 'json',
                doneResult: res => {
                    this.setState({ byStageList: res.data });
                }
            }
            $.sendRequest(options);
        } else {
            this.setState({ byStageList: [] });
        }
    }

    getStageList = (statusId = null) => {
        // if (statusId) {
            const options = {
                method: 'POST',
                url: API_URL.investigation.queryStageList,
                data: { statusId },
                dataType: 'json',
                doneResult: res => {
                    const {stageList = []} = res
                    this.setState({ stageList: stageList || [] });
                }
            }
            $.sendRequest(options);
        // } else {
        //     this.setState({ stageList: [] });
        // }
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            case 'investigationSponsor':
            case 'cro':
            case 'pm':
            case 'pmLeader':
            case 'pmlLeader':
            case 'bd':
            case 'customerTag': {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                onChange(searchParams);
                break;
            }
            case 'leaderName': {
                const { value: id, text: name } = value;
                searchParams[`${key}Field`] = id;
                searchParams[`${key}Name`] = name;
                onChange(searchParams);
                break;
            }
            case 'lineOfBusinessIds':
            case 'originalDiseaseNames':
            case 'secondLineNames':
            case 'contractTypeIds':
            case 'stageIds':
            case 'evolve':
                if(key === 'evolve'){
                    const { customerCompanyName } = value;
                    searchParams.evolve = searchParams.evolve+','+customerCompanyName;
                }else{
                    searchParams[key] = value ? value.join(',') : undefined;
                    if (key === 'lineOfBusinessIds') {
                        searchParams.secondLineNames = undefined;
                    }
                }
                onChange(searchParams);
                break;
            case 'investigationAreaId':
                searchParams[key] = value;
                searchParams.diseaseId = undefined;
                searchParams.diseaseClassId = undefined;
                searchParams.originalDiseaseName = undefined;
                onChange(searchParams);
                this.handleChange(undefined, 'diseaseClassId');
                this.loadDiseaseClassList();
                this.loadDiseaseList();
                break;
            case 'diseaseClassId':
                searchParams[key] = value;
                searchParams.diseaseId = undefined;
                onChange(searchParams);
                this.loadDiseaseList();
                break;
            case 'diseaseId':
                value?searchParams.diseaseId = value:searchParams.diseaseId = undefined;
                onChange(searchParams);
                break;
            case 'investigationMedicineType':
                searchParams[key] = value;
                searchParams.investigationByStageId = undefined;
                onChange(searchParams);
                this.loadInvestigationByStageList();
                break;
            case 'statusId':
                searchParams[key] = value;
                searchParams.stageIds = undefined;
                onChange(searchParams);
                this.getStageList(value);
                break;
            default:
                searchParams[key] = value;
                onChange(searchParams);
                break;
        }
    }

    handleSearchChange = (value, option, key) => {
        const { searchParams, onChange } = this.props;
        let list = searchParams[key] ? searchParams[key].split(',') : [];
        if (option) {
            list.push(option.value);
        } else {
            list = list.filter(i => i != value);
        }
        if( !value.length ) {
            list = [];
        }
        searchParams[key] = list.join(',');
        onChange(searchParams);
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    viewPercent = () => {
        location.href = `./#/proPercent`;
    }

    advancedExport = () => {
        const { searchParams:{ stageIds } } = this.props;
        this.setState({advancedExportShow: true}, () => {
            this.exportRef.show(stageIds);
        })
        
    }

    advancedExportShow = () =>{
        this.setState({advancedExportShow: false})
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    showCreateModal = () => {
        this.props.showCreateModal();
    }

    parseInvProceedData = res => {
        if ((res.typeConfigureList)) {
            const sourceData = res.typeConfigureList;
            const data = sourceData.map(item => ({
                text:item.typeValue,
                value: item.typeConfigureId,
                fetching: false,
            }));
            this.setState({ invProceedOptions: data });
        } else {
            this.setState({ invProceedOptions: [] });
        }
    }

    invProceedSelectChange = (value = []) => {
        const { onChange, searchParams } = this.props;
        let investigationProceed =''
        value.forEach((item, index) => {
            if(index == value.length-1){
                investigationProceed = investigationProceed + item.key;
            }else{
                investigationProceed = investigationProceed + item.key+',';
            }
        });
        searchParams.investigationProceed = investigationProceed
        this.setState({investigationProceeds:value})
        onChange(searchParams);
    }


    render() {
        const {
            isSimple,
            areaList,
            typeList,
            levelList,
            invStatusList,
            businessList,
            testeeTypeList,
            contractTypeList,
            GlobalTypeList,
            MedicineTypeList,
            searchParams,
        } = this.props;
        const {
            expand,
            diseaseList,
            byStageList,
            diseaseClassList,
            invProceedOptions,
            investigationProceeds,
            advancedExportShow,
            stageList,
        } = this.state;
        const {
            investigationAreaId,
            diseaseClassId,
            investigationMedicineType = [],
            lineOfBusinessIds,
            originalDiseaseNames,
            contractSignCompanyIds,
            investigationSponsorIds,
            croIds,
            secondLineNames,
            contractTypeIds,
        } = searchParams;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            const arr = (lineOfBusinessIds || '').split(',');
            if (arr.some(j => j == i.typeConfigureId)) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const globalTypeOption = GlobalTypeList.map(d => <Option key={d.value} title={d.typeValue}>{d.label}</Option>);
        const levelOption = levelList.map(d => <Option key={String(d.typeConfigureId)} title={d.typeValue}>{d.typeValue}</Option>);
        const invStatusOption = invStatusList.map(d => <Option key={String(d.typeConfigureId)} title={d.typeValue}>{d.typeValue}</Option>);
        const typeOption = typeList.map(d => <Option key={String(d.typeConfigureId)} title={d.typeValue}>{d.typeValue}</Option>);
        const stageOption = stageList.map(d => <Option key={String(d.typeConfigureId)} title={d.typeValue}>{d.typeValue}</Option>);
        const contractTypeListOption = contractTypeList.map(d => <Option key={String(d.typeConfigureId)} title={d.typeValue}>{d.typeValue}</Option>);
        const startStateOption = StartStateList.map(d => <Option key={d.value} title={d.label}>{d.label}</Option>);
        const areaListOption = areaList.map(d => <Option key={String(d.investigationAreaId)} title={d.investigationAreaName}>{d.investigationAreaName}</Option>);
        const diseaseClassOption = diseaseClassList.map(d => <Option key={String(d.diseaseClassId)} title={d.diseaseClassName}>{d.diseaseClassName}</Option>);
        const diseaseOption = diseaseList.map(d => <Option key={String(d.diseaseName)} showValue={d.diseaseName} title={d.diseaseName}>{d.diseaseName}</Option>);
        const businessOption = businessList.map(d => <Option key={String(d.typeConfigureId)} title={d.typeValue}>{d.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(d => <Option key={d} title={d}>{d}</Option>);
        const investigationNatureOption = InvestigationNatureList.map(d => <Option key={d.value} title={d.label}>{d.label}</Option>);
        const testeeTypeOption = testeeTypeList.map(d => <Option key={String(d.typeConfigureId)} title={d.typeValue}>{d.typeValue}</Option>);
        // const medicineTypeOptions = MedicineTypeList.map(d => <Option key={String(d.value)} title={d.label}>{d.label}</Option>);
        const byStageOption = byStageList.map(d => <Option key={String(d.investigationByStageId)} title={d.investigationByStageName}>{d.investigationByStageName}</Option>);
        const { curRole } = sessionStorage;
        const maxHeight = expand ? 280 : 40;
        return (
            <div style={{marginBottom: 16}}>
                <div className="search-bar expand" style={{ maxHeight: maxHeight }}>
                    <div className="expand-box">
                        <a onClick={this.toggleHeight}>
                            {expand ? "收起" : "展开"}
                            <Icon className="expand-icon" type={expand ? "up" : "down"} />
                        </a>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目简称</label>
                        <Input
                            placeholder="请输入"
                            style={{width: 150}}
                            value={searchParams.investigationName}
                            onChange={e => this.handleChange(e.target.value, 'investigationName')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目编号</label>
                        <Input
                            placeholder="请输入"
                            style={{ width: 100 }}
                            value={searchParams.investigationCode}
                            onChange={e => this.handleChange(e.target.value, 'investigationCode')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">JDE主项目号</label>
                        <Input
                            placeholder="请输入"
                            style={{ width: 100 }}
                            value={searchParams.investigationJdeContractCode}
                            onChange={e => this.handleChange(e.target.value, 'investigationJdeContractCode')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目类型</label>
                        <Select
                            allowClear={true}
                            style={{ width: 160 }}
                            placeholder="请选择"
                            value={searchParams.investigationGlobalType}
                            onChange={value => this.handleChange(value, 'investigationGlobalType')}
                        >
                            {globalTypeOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目级别</label>
                        <Select
                            placeholder="请选择"
                            allowClear={true}
                            style={{ width: 80 }}
                            value={searchParams.levelId}
                            onChange={value => this.handleChange(value, 'levelId')}
                        >
                            {levelOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目状态</label>
                        <Select
                            placeholder="请选择"
                            allowClear={true}
                            style={{ width: 130 }}
                            value={searchParams.statusId}
                            onChange={value => this.handleChange(value, 'statusId')}
                        >
                            {invStatusOption}
                        </Select>
                    </div>
                    <div className="search-item" style={{ height: 30 }}>
                        <label htmlFor="" className="ui-label">项目阶段</label>
                        <Select
                            className="multiple-stage"
                            mode="multiple"
                            filterOption={false}
                            dropdownMatchSelectWidth={false}
                            placeholder="请选择"
                            style={{ width: 160 }}
                            value={searchParams.stageIds ? searchParams.stageIds.split(',') : []}
                            onChange={value => this.handleChange(value, 'stageIds')}
                        >
                            {stageOption}
                        </Select>
                    </div>
                    <div className="search-item">
                    <label htmlFor="" className="ui-label">项目进展</label>
                    <SearchMulSelect
                        keyword='keyword'
                        className="hospital-multiple"
                        url={API_URL.investigation.queryByParams}
                        style={{ width: 160 }}
                        searchParam={{typeName: 'INVESTIGATION_PROCEED'}}
                        value={investigationProceeds || []}
                        sourceData={invProceedOptions}
                        parseData={this.parseInvProceedData}
                        handleSelect={this.invProceedSelectChange}
                        placeholder='请输入项目进展检索'
                    />
                </div>
                    {
                        !isSimple &&
                            <div className="search-item">
                            <label htmlFor="" className="ui-label">中心启动情况</label>
                            <Select
                                placeholder="请选择"
                                allowClear={true}
                                value={searchParams.siteStartState}
                                style={{ width: 140 }}
                                onChange={value => this.handleChange(value, 'siteStartState')}
                            >
                                {startStateOption}
                            </Select>
                        </div>
                    }
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目分类</label>
                        <Select
                            placeholder="请选择"
                            allowClear={true}
                            style={{ width: 120 }}
                            value={searchParams.typeId}
                            onChange={value => this.handleChange(value, 'typeId')}
                        >
                            {typeOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目名称</label>
                        <Input
                            placeholder="请输入"
                            style={{ width: 140 }}
                            value={searchParams.investigationSpecialName}
                            onChange={e => this.handleChange(e.target.value, 'investigationSpecialName')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目领域</label>
                        <Select
                            placeholder="请选择"
                            allowClear={true}
                            value={investigationAreaId}
                            style={{ width: 120 }}
                            onChange={value => this.handleChange(value, 'investigationAreaId')}
                        >
                            {areaListOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">疾病分类</label>
                        <Select
                            placeholder="请选择"
                            allowClear={true}
                            disabled={!investigationAreaId}
                            value={searchParams.diseaseClassId}
                            style={{ width: 120 }}
                            onChange={value => this.handleChange(value, 'diseaseClassId')}
                        >
                            {diseaseClassOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">疾病</label>
                        {
                            investigationAreaId ?
                                diseaseClassId ?
                                    <Select
                                        placeholder="请选择"
                                        mode="multiple"
                                        allowClear={true}
                                        value={originalDiseaseNames ? originalDiseaseNames.split(',') : []}
                                        style={{ width: 162 }}
                                        onChange={value => this.handleChange(value, 'originalDiseaseNames')}
                                    >
                                        {diseaseList.map(d => <Option key={String(d.diseaseId)} value={String(d.diseaseName)}>{d.diseaseName}</Option>)}
                                    </Select>
                                :
                                    // <AutoComplete
                                    //     onSearch={this.loadDiseaseList}
                                    //     allowClear={true}
                                    //     style={{width: 120}}
                                    //     optionLabelProp="showValue"
                                    //     placeholder="输入名称检索"
                                    //     onChange={value => this.handleChange(value, 'diseaseId')}
                                    // >
                                    //     {diseaseOption}
                                    // </AutoComplete>
                                    <SearchMulRetrieve
                                        keyword='keyword'
                                        style={{ width: 162 }}
                                        placeholder="输入名称检索"
                                        value={originalDiseaseNames ? originalDiseaseNames.split(',') : []}
                                        params={{ limit: 20, investigationAreaId }}
                                        url={API_URL.common.queryAllDisease}
                                        config={{ id: 'diseaseName', name: 'diseaseName' }}
                                        onChange={(value, option) => this.handleSearchChange(value, option, 'originalDiseaseNames')}
                                    />
                                :
                                <Input
                                    placeholder="请输入"
                                    style={{width: 162}}
                                    value={searchParams.originalDiseaseName}
                                    onChange={e => this.handleChange(e.target.value, 'originalDiseaseName')}
                                    onKeyPress={this.enterSearch}
                                />
                        }
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">研究产品类型</label>
                        {/* <Select
                            placeholder="请选择"
                            allowClear={true}
                            value={investigationMedicineType}
                            style={{ width: 150 }}
                            onChange={value => this.handleChange(value, 'investigationMedicineType')}
                        >
                            {medicineTypeOptions}
                        </Select> */}
                        <Cascader
                            allowClear={true}
                            placeholder="请选择"
                            options={MedicineTypeList}
                            value={investigationMedicineType}
                            style={{ width: 150 }}
                            onChange={value => this.handleChange(value, 'investigationMedicineType')}
                        />
                    </div>
                    <div className="search-item showInvestigation">
                        <label htmlFor="" className="ui-label">项目分期</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width: 120 }}
                            disabled={!investigationMedicineType[0]}
                            value={searchParams.investigationByStageId}
                            onChange={value => this.handleChange(value, 'investigationByStageId')}
                        >
                            {byStageOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">药物(疗法)分类/主要作用靶点</label>
                        <Input
                            placeholder="请输入"
                            style={{ width: 120 }}
                            value={searchParams.drugMainTargets}
                            onChange={e => this.handleChange(e.target.value, 'drugMainTargets')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">受试者类型</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{ width: 120 }}
                            value={searchParams.testeeTypeId}
                            onChange={value => this.handleChange(value, 'testeeTypeId')}
                        >
                            {testeeTypeOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">合同签署方</label>
                        <SearchMulRetrieve
                            keyword='customerCompanyName'
                            style={{ width: 180 }}
                            placeholder="输入名称检索"
                            value={contractSignCompanyIds ? contractSignCompanyIds.split(',') : []}
                            // 仅有恢复的已选值时挂载即查（用于回显名称标签），全新进入空值不发
                            shouldSearch={!!contractSignCompanyIds}
                            params={{ limit: 20 }}
                            url={API_URL.investigation.queryCustomerCompanyByName}
                            config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                            onChange={(value, option) => this.handleSearchChange(value, option, 'contractSignCompanyIds')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">申办方</label>
                        <SearchMulRetrieve
                            keyword='customerCompanyName'
                            style={{ width: 180 }}
                            placeholder="输入名称检索"
                            value={investigationSponsorIds ? investigationSponsorIds.split(',') : []}
                            // 仅有恢复的已选值时挂载即查（用于回显名称标签），全新进入空值不发
                            shouldSearch={!!investigationSponsorIds}
                            params={{ limit: 20, natureName: '申办方' }}
                            url={API_URL.investigation.queryCustomerCompanyByName}
                            config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                            onChange={(value, option) => this.handleSearchChange(value, option, 'investigationSponsorIds')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">客户标签</label>
                        <SearchRetrieve
                            keyword='tagValue'
                            style={{ width: 140 }}
                            placeholder="输入客户标签检索"
                            value={searchParams.customerTagName}
                            params={{ limit: 20 }}
                            url={API_URL.contract.queryCustomerTagList}
                            config={{ id: 'customerTagId', name: 'tagValue' }}
                            onChange={value => this.handleChange(value, 'customerTag')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">CRO</label>
                        <SearchMulRetrieve
                            keyword='customerCompanyName'
                            style={{ width: 162 }}
                            placeholder="输入名称检索"
                            value={croIds ? croIds.split(',') : []}
                            // 仅有恢复的已选值时挂载即查（用于回显名称标签），全新进入空值不发
                            shouldSearch={!!croIds}
                            params={{ limit: 20, natureName: 'CRO' }}
                            url={API_URL.investigation.queryCustomerCompanyByName}
                            config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                            onChange={(value, option) => this.handleSearchChange(value, option, 'croIds')}
                        />
                    </div>
                    <div className="search-item" style={{ height: 30 }}>
                        <label htmlFor="" className="ui-label">业务线</label>
                        <Select
                            mode="multiple"
                            allowClear={true}
                            filterOption={false}
                            placeholder="请选择"
                            style={{width: 120}}
                            value={lineOfBusinessIds ? lineOfBusinessIds.split(',') : []}
                            className="multiple-stage"
                            onChange={value => this.handleChange(value, 'lineOfBusinessIds')}
                        >
                            {businessOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">执行业务线二级分类</label>
                        <Select
                            mode="multiple"
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 180}}
                            disabled={!lineOfBusinessIds}
                            value={secondLineNames ? secondLineNames.split(',') : []}
                            onChange={value => this.handleChange(value, 'secondLineNames')}
                        >
                            {secondLineOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">项目性质</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            value={searchParams.investigationNature}
                            onChange={value => this.handleChange(value, 'investigationNature')}
                        >
                            {investigationNatureOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">CDE登记号</label>
                        <Input
                            placeholder="请输入"
                            style={{width: 120}}
                            value={searchParams.cdeNum}
                            onChange={e => this.handleChange(e.target.value, 'cdeNum')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">计收入确认方式</label>
                        <Select
                            placeholder="请选择"
                            mode="multiple"
                            allowClear={true}
                            style={{ width: 160 }}
                            value={contractTypeIds ? contractTypeIds.split(',') : []}
                            onChange={value => this.handleChange(value, 'contractTypeIds')}
                        >
                            {contractTypeListOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">合同额含税/人民币(元)</label>
                        <InputGroup compact>
                            <Select
                                value={searchParams.conAmountSymbol}
                                style={{ width: 40 }}
                                onChange={value => this.handleChange(value, 'conAmountSymbol')}
                            >
                                <Option value="GreatThan">&gt;</Option>
                                <Option value="NotLess">&ge;</Option>
                                <Option value="LessThan">&lt;</Option>
                                <Option value="NotGreat">&le;</Option>
                                <Option value="Equals">=</Option>
                            </Select>
                            <InputNumber
                                value={searchParams.conAmount}
                                style={{width:120}}
                                placeholder="请输入"
                                onChange={value => this.handleChange(value, 'conAmount')}
                                onKeyPress={this.enterSearch}
                            />
                        </InputGroup>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">PM</label>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width: 140 }}
                            placeholder="输入姓名/工号检索"
                            value={searchParams.pmName}
                            params={{ limit: 20 }}
                            url={API_URL.investigation.queryUserByKey}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={value => this.handleChange(value, 'pm')}
                        />
                    </div>
                    {
                        fp.contains(curRole, ['CRCM', 'CRCC']) &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">是否为自己区域内的项目</label>
                            <Select
                                placeholder="请选择"
                                value={searchParams.cityManagerFilter}
                                style={{ width: 80 }}
                                onChange={value => this.handleChange(value, 'cityManagerFilter')}
                            >
                                <Option value="1">是</Option>
                                <Option value="0">否</Option>
                            </Select>
                        </div>
                    }
                    {
                        !isSimple &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">PM主管</label>
                            <SearchRetrieve
                                keyword='keyword'
                                style={{ width: 140 }}
                                placeholder="输入姓名/工号检索"
                                value={searchParams.pmLeaderName}
                                params={{ limit: 20 }}
                                url={API_URL.investigation.queryUserByKey}
                                config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                onChange={value => this.handleChange(value, 'pmLeader')}
                            />
                        </div>
                    }
                    {
                        !isSimple &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">PML上级</label>
                            <SearchRetrieve
                                keyword='keyword'
                                style={{ width: 140 }}
                                placeholder="输入姓名/工号检索"
                                value={searchParams.pmlLeaderName}
                                params={{ limit: 20 }}
                                url={API_URL.investigation.queryUserByKey}
                                config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                onChange={value => this.handleChange(value, 'pmlLeader')}
                            />
                        </div>
                    }
                    {
                        !isSimple &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">BD</label>
                            <SearchRetrieve
                                keyword='keyword'
                                style={{ width: 140 }}
                                placeholder="输入姓名/工号检索"
                                value={searchParams.bdName}
                                params={{ limit: 20 }}
                                url={API_URL.investigation.queryUserByKey}
                                config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                onChange={value => this.handleChange(value, 'bd')}
                            />
                        </div>
                    }
                    {
                        !isSimple &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">领域leader</label>
                            <SearchRetrieve
                                keyword='leaderName'
                                style={{ width: 140 }}
                                placeholder="输入姓名/工号检索"
                                value={searchParams.leaderNameName}
                                params={{ limit: 20 }}
                                url={API_URL.user.queryLeaderList}
                                config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                onChange={value => this.handleChange(value, 'leaderName')}
                            />
                        </div>
                    }
                    {
                        !isSimple &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">津石计划负责中心数量</label>
                            <InputGroup compact>
                                <Select
                                    value={searchParams.sitePlanSymbol}
                                    style={{ width: 40 }}
                                    onChange={value => this.handleChange(value, 'sitePlanSymbol')}
                                >
                                    <Option value="GreatThan">&gt;</Option>
                                    <Option value="NotLess">&ge;</Option>
                                    <Option value="LessThan">&lt;</Option>
                                    <Option value="NotGreat">&le;</Option>
                                    <Option value="Equals">=</Option>
                                </Select>
                                <InputNumber
                                    value={searchParams.sitePlan}
                                    style={{width:120}}
                                    placeholder="请输入"
                                    onChange={value => this.handleChange(value, 'sitePlan')}
                                    onKeyPress={this.enterSearch}
                                />
                            </InputGroup>
                        </div>
                    }
                    {
                        !isSimple &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">是否为对垒项目</label>
                            <Select
                                placeholder="请选择"
                                value={searchParams.isAgainstInvestigation}
                                style={{ width: 80 }}
                                onChange={value => this.handleChange(value, 'isAgainstInvestigation')}
                            >
                                <Option value="1">是</Option>
                                <Option value="0">否</Option>
                            </Select>
                        </div>
                    }
                </div>
                <div className="search-bar flex-end">
                    <div className="search-item" style={{ lineHeight: '28px', color: isSimple && '#108ee9' }}>
                        <Switch
                            size="small"
                            checked={isSimple}
                            onChange={this.props.setMode}
                            style={{marginTop: 7, marginRight: 6}}
                        />
                        简洁模式
                    </div>
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        <Button type="primary" onClick={this.reset}>重置</Button>
                        {
                            <Button type="primary" onClick={this.advancedExport}>高级导出</Button>
                        }
                        {curRole == 'CTA' && <Button type="primary" onClick={() => this.props.showCreate(true)}>添加</Button>}
                    </div>
                </div>
                {
                    advancedExportShow && 
                    <AdvancedExport
                        advancedExportShow={this.advancedExportShow}
                        stageList={stageList}
                        ref={el => this.exportRef = el}
                        searchArray={{ ...searchParams }}
                    />
                }
                
            </div>
        );
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/investigation/Filter.js